import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import { NgClass, NgIf } from '@angular/common';

@Component({
    selector: 'app-card',
    template: `
    <div class="card">
      <div class="card-body">
        <h4 class="card-title" [ngClass]="{'collapsed': collapsed}">
          <a role="button" aria-expanded="true" class="expand-title" (click)="toggleCollapse()">
            {{title}}
            <i class="fa fa-angle-down expand-arrow" aria-hidden="true"></i>
          </a>
        </h4>
        <div *ngIf="!collapsed">
          <ng-content></ng-content>
        </div>
      </div>
    </div>
  `,
    styles: [
        '.expand-arrow {float: right;}',
        '.card-title {font-size: 15px; display: flex;}',
        '.expand-title {flex: auto; cursor: pointer;}',
        '.card-title.collapsed {margin-bottom: -10px; }'
    ],
    standalone: true,
    imports: [NgClass, NgIf]
})
export class CardComponent implements OnChanges, OnInit {

  @Input() title: string;
  @Input() collapsed = false;

  constructor() {

  }

  ngOnChanges(changes: SimpleChanges): void {

  }

  ngOnInit() {
    // console.log(this.optionsMap);
  }

  toggleCollapse() {
    this.collapsed = !this.collapsed;
  }
}
